import { render } from "./TabsPage.vue?vue&type=template&id=26da1394&scoped=true"
import script from "./TabsPage.vue?vue&type=script&lang=js"
export * from "./TabsPage.vue?vue&type=script&lang=js"

import "./TabsPage.vue?vue&type=style&index=0&id=26da1394&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26da1394"]])

export default __exports__